import React, { FC } from "react";
import { GetServerSideProps, GetServerSidePropsContext } from "next";
import { withRouter } from "next/router";
import { useTheme } from '@mui/material/styles';
import { WithRouterProps } from "next/dist/client/with-router";
import Head from "next/head";
import Footer from "../src/components/Footer/Footer";
import ResetPassword from "../src/pages/ResetPassword/ResetPassword";
import { useColorModeContext } from "../src/contexts/CustomThemeProvider";


interface ResetPasswordProps extends WithRouterProps {}

const ResetPasswordPage: FC<ResetPasswordProps> = () => {
    const seoTitle = "Reset Password | That's The Ticket";
    const theme = useTheme();

    const { setColorMode } = useColorModeContext();
    setColorMode("dark");
    
    return (
        <>
            <Head>
                <title>{`${seoTitle}`}</title>
                <meta key="ogTitle" property="og:title" content={seoTitle} />
                <meta key="twitterTitle" name="twitter:title" content={seoTitle} />
                <style>
                {`
                  body {
                    background-color: ${theme.colors.black};
                  }
                `}
                </style>
            </Head>

            <ResetPassword />

            <Footer />
        </>

    );
}

export default withRouter(ResetPasswordPage);

export const getServerSideProps: GetServerSideProps = async ({ params }: GetServerSidePropsContext) => {
    return {
        props: {}
    }
}